// @flow
import React from 'react';
import {
  CodeTabGroup,
  CodeBlock,
  CodeTab,
  CodegenSnippet,
} from 'docs/components';
import {ContentGroupItem} from 'docs/util';
import {LANGUAGES} from '../../core/CodegenSnippet/constants';
import {useApiExplorer} from './ApiExplorerProvider';

const emptyCodeBlocks = LANGUAGES.map((lang) => ({
  lang,
  codegenError: null,
  generatedCode: '',
  overriddenCodeBlock: null,
}));

export const CodegenExample = () => {
  const {
    state: {codegenExample},
  } = useApiExplorer();

  if (codegenExample?.error) {
    return (
      <CodeTabGroup
        items={[
          new ContentGroupItem(
            '',
            '',
            (
              <CodeTab
                key="codegen-example"
                id="codegen-example"
                title="Request"
              >
                <CodeBlock numbered={false}>{codegenExample.error}</CodeBlock>
              </CodeTab>
            ),
          ),
        ]}
        codeTabGroupID="codetab_api_explorer_request"
      />
    );
  } else if (codegenExample?.generatedCodeBlocks) {
    return (
      <CodegenSnippet
        generatedCodeBlocks={codegenExample.generatedCodeBlocks}
        codeTabGroupID="codetab_api_explorer_request"
      />
    );
  } else {
    return (
      <CodegenSnippet
        generatedCodeBlocks={emptyCodeBlocks}
        codeTabGroupID="codetab_api_explorer_request"
      />
    );
  }
};
